import { render, staticRenderFns } from "./WidowedDistributionToOtherYN.vue?vue&type=template&id=52fdca65"
import script from "./WidowedDistributionToOtherYN.vue?vue&type=script&lang=js"
export * from "./WidowedDistributionToOtherYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports